import React from 'react';

import QuestionWithTooltipComponent from '../../../questionWithTooltipComponent/questionWithTooltipComponent';

import './errorComponent.css';

const ErrorComponent = ({
  errorMessage = '',
  toolTipPosition = 'right',
  toolTipTxt = '',
}) => {
  return (
    <div className="et-n-input-field-error-component-container">
      {errorMessage}
      {toolTipTxt && (
        <div className="et-n-ifer-tooltip-wrap">
          <QuestionWithTooltipComponent
            toolTipTxt={toolTipTxt}
            toolTipPosition={toolTipPosition}
          />
        </div>
      )}
    </div>
  );
};

export default ErrorComponent;
